import PageNavigation from './PageNavigation';

export default PageNavigation;



// WEBPACK FOOTER //
// ./src/components/PageNavigation/index.ts